"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _menu = require("../utils/menu");
var _lodash = require("lodash");
var _common = require("../utils/common");
var _constant = require("../constant");
/**
 * 数据管理的操作基类
 */
var Requester = /*#__PURE__*/function () {
  function Requester(_ref, uuid) {
    var tableTree = _ref.tableTree,
      rawTableList = _ref.rawTableList;
    (0, _classCallCheck2.default)(this, Requester);
    this.tableTree = tableTree;
    this.rawTableList = rawTableList;
    this.errMsg = [];
    this.uuid = uuid;
  }

  // ----------------------------------------------------------------------
  /**
   * 基于table树所有节点的数据，构造出从主表开始的数据树
   */
  (0, _createClass2.default)(Requester, [{
    key: "buildDataTreeByTableTree",
    value: function buildDataTreeByTableTree() {
      var _this = this;
      var mainDataList = (0, _lodash.cloneDeep)(this.tableTree.dataList);
      mainDataList.forEach(function (data) {
        _this.buildDataTree(data, _this.tableTree);
      });
      return mainDataList;
    }

    /**
     * 补充指定table的一条数据的所有子table的关联数据（递归）
     * @param {*} $data table实例的一条数据
     * @param {*} table table实例
     */
  }, {
    key: "buildDataTree",
    value: function buildDataTree($data, table) {
      var _this2 = this;
      var data = $data;
      var forkTableList = table.forkTableList;
      forkTableList.forEach(function (forkTableAndRelation) {
        var forkTable = forkTableAndRelation.forkTable,
          relationObj = forkTableAndRelation.relationObj;
        var relation = relationObj.relation,
          ratio = relationObj.ratio;
        var forkDataList = forkTable.dataList;
        var leftFieldData = (0, _common.getValueByPath)(data, relation[0]);
        if ((0, _common.noneValue)(leftFieldData)) {
          return;
        }
        var forkTableKey = "".concat(_constant.TABLETAG).concat(forkTable.tableKey);
        var forkTableDataList = [];
        // 普通关联的键在子表、普通关联的键在父表
        if (relation[1] === _menu.RelationStatus.RIGHT || relation[1] === _menu.RelationStatus.LEFT) {
          forkTableDataList = (0, _lodash.cloneDeep)(forkDataList.filter(function (forkData) {
            return "".concat(leftFieldData) === "".concat((0, _common.getValueByPath)(forkData, relation[2]));
          }));
        }
        // link关联的键在子表
        if (relation[1] === _menu.RelationStatus.IN) {
          forkTableDataList = (0, _lodash.cloneDeep)(forkDataList.filter(function (forkData) {
            var rightFieldData = (0, _common.getValueByPath)(forkData, relation[2]);
            if ((0, _common.noneValue)(rightFieldData)) {
              return false;
            }
            return "".concat(rightFieldData).split(_constant.LINKSPLIT).indexOf("".concat(leftFieldData)) > -1;
          }));
        }
        // link关联的键在父表
        if (relation[1] === _menu.RelationStatus.INCLUDE) {
          var keyArray = "".concat(leftFieldData).split(_constant.LINKSPLIT);
          var resultArray = [];
          keyArray.forEach(function (key) {
            var result = forkDataList.find(function (forkData) {
              var rightFieldData = (0, _common.getValueByPath)(forkData, relation[2]);
              return !(0, _common.noneValue)(rightFieldData) && "".concat(key) === "".concat(rightFieldData);
            });
            if (result) {
              resultArray.push((0, _lodash.cloneDeep)(result));
            }
          });
          forkTableDataList = resultArray;
          // ----旧的按接口顺序逻辑
          // forkTableDataList = cloneDeep(forkDataList.filter((forkData) => {
          //   const rightFieldData = getValueByPath(forkData, relation[2]);
          //   if (noneValue(rightFieldData)) {
          //     return false;
          //   }
          //   return `${leftFieldData}`.split(LINKSPLIT).indexOf(`${rightFieldData}`) > -1;
          // }));
        }

        // 递归调用
        if (forkTableDataList && forkTableDataList.length > 0) {
          forkTableDataList.forEach(function (childData) {
            _this2.buildDataTree(childData, forkTable);
          });
          if (ratio === 1) {
            // eslint-disable-next-line
            data[forkTableKey] = forkTableDataList[0];
          } else {
            data[forkTableKey] = forkTableDataList;
          }
        }
      });
    }

    // ----------------------------------------------------------------------
    /**
     * 基于旧的数据树，还原table树所有节点的数据
     * @param {*} dataList
     * @param {*} table
     */
  }, {
    key: "regainTableTreeByDataTree",
    value: function regainTableTreeByDataTree(dataList, table) {
      var _this3 = this;
      var primaryKey = table.primaryKey;
      var forkTableArray = table.forkTableList.map(function (item) {
        return item.forkTable;
      });
      dataList.forEach(function (data) {
        // 去重判断：某个节点数据可能被多个父节点数据引用（避免重复添加）
        var findData = table.dataList.find(function (oldData) {
          return oldData[primaryKey] === data[primaryKey];
        });
        if (!findData) {
          table.dataList.push((0, _common.cloneRawData)(data));
        }

        // 对每条数据的子数据，要处理一下引用的子表数据集
        Object.keys(data).forEach(function (key) {
          // 如果符合子数据集的key值，说明是子表数据
          var forkTable = forkTableArray.find(function (item) {
            return "".concat(_constant.TABLETAG).concat(item.tableKey) === key;
          });
          var keyValue = data[key];
          if (forkTable && keyValue) {
            // 1对1关系挂的是对象形式，统一转成数组处理
            if (!Array.isArray(keyValue)) {
              keyValue = [keyValue];
            }
            _this3.regainTableTreeByDataTree(keyValue, forkTable);
          }
        });
      });
    }
  }]);
  return Requester;
}();
var _default = Requester;
exports.default = _default;